import {
  createPatientWeight,
  PatientWeight,
  UpdatePatientWeight,
} from "../types";
import { api } from "./api";
import { TAGS } from "../constants";

export const weightTrackerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPatientWeight: builder.query<PatientWeight[], number>({
      query: (patientId) => ({
        url: `/api/weight-tracker/patient/${patientId}`,
        method: "GET",
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAGS.PATIENT_WEIGHTS, id: args },
      ],
    }),
    updatePatientWeight: builder.mutation<PatientWeight, UpdatePatientWeight>({
      query: ({ id, ...body }) => ({
        url: `/api/weight-tracker/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_returns, _error, args) => [
        { type: TAGS.PATIENT_WEIGHTS, id: args.patient_id },
      ],
    }),
    createPatientWeight: builder.mutation<PatientWeight, createPatientWeight>({
      query: (body) => ({
        method: "POST",
        url: `/api/weight-tracker`,
        body,
      }),
      invalidatesTags: (_returns, _error, args) => [
        { type: TAGS.PATIENT_WEIGHTS, id: args.patient_id },
      ],
    }),
  }),
});

export const {
  useGetPatientWeightQuery,
  useUpdatePatientWeightMutation,
  useCreatePatientWeightMutation,
} = weightTrackerApi;
